<template>
    <div class="dk-wizard-lead-form-modal__header tw-w-full tw-px-6 tw-py-3 tw-bg-brand-primary tw-text-white">
        <div class="dk-wizard-lead-form-modal__header-top tw-full tw-flex tw-justify-between tw-items-center">
            <h4 class="headline-sm lg:tw-font-semibold">
                {{ fullName }}
            </h4>
            <dk-button
                class="!tw-text-white !tw-p-0"
                variant="ghost"
                type="button"
                @click="hideModal('dk-wizard-lead-form-modal')"
            >
                <dk-icon name="ds-close-default" size="s" />
            </dk-button>
        </div>
        <h6 v-if="hasHeaderText" class="dk-wizard-lead-form-modal__header-middle tw-mt-1 subtitle-sm tw-line-clamp-1">
            <span
                v-if="versionName"
                class="dk-wizard-lead-form-modal__header-version tw-w-fit tw-mr-[2px] tw-font-semibold"
            >
                {{ versionName }}
                <span v-if="selectedColor"> / </span>
            </span>
            <span v-if="selectedColor" class="wizard-header__version-color">
                {{ selectedColor }}
            </span>
        </h6>
        <template v-if="hasDealerSelection">
            <small
                v-if="!showDealerInfo"
                class="dk-wizard-lead-form-modal__header-dealer--empty tw-text-2xs lg:tw-text-xs tw-leading-2xs lg:tw-leading-xs tw-text-blue-200 tw-line-clamp-1"
            >
                {{ $t('dealer-selection.dealer-not-selected-yet') }}
            </small>
            <small
                v-else
                class="dk-wizard-lead-form-modal__header-dealer--chosen tw-flex tw-text-2xs lg:tw-text-xs tw-leading-2xs lg:tw-leading-xs tw-text-negative tw-line-clamp-1"
            >
                <span class="dk-wizard-lead-form-modal__header-dealer-name tw-mr-[2px]">
                    {{ selectedDealer.name }}
                </span>
                -
                <span class="dk-wizard-lead-form-modal__header-dealer-address tw-ml-[2px] tw-capitalize">
                    {{ selectedDealer.address.toLowerCase() }}
                </span>
            </small>
        </template>
    </div>
</template>

<script>
import { dkModalAware } from '@v4/common/components/mixins/modal';

export default {
    name: 'DkWizardLeadFormHeader',
    components: {
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'),
        }),
    },
    mixins: [dkModalAware],
    props: {
        fullName: {
            type: String,
            default: '',
        },
        hasDealerSelection: {
            type: Boolean,
            default: false,
        },
        selectedDealer: {
            type: Object,
            default: () => ({}),
        },
        selectedColor: {
            type: String,
            default: '',
        },
        versionName: {
            type: String,
            default: '',
        },
    },
    computed: {
        showDealerInfo() {
            return this.selectedDealer && this.selectedDealer.name && this.selectedDealer.address;
        },
        hasHeaderText() {
            return this.selectedColor || this.versionName;
        },
    },
};
</script>
